import { Spreadsheet } from "@/components/FlowSheetEditor/services/modal"
import { ChemicalComponent } from "@/services/chemical-component"
import { Button, Form, Input, Modal, ModalProps, Row, Space } from "antd"
import { useEffect } from "react"
import { createRoot } from "react-dom/client"


interface CreateSpreadsheetModalProps extends ModalProps {
  onSuccess?: (values: any) => void
  component?: ChemicalComponent.Modal
  spreadsheet?: Spreadsheet
}

export const CreateSpreadsheetModal = (props: CreateSpreadsheetModalProps) => {
  const {onCancel, onSuccess, spreadsheet} = props
  const [form] = Form.useForm()

  useEffect(() => {
    if (spreadsheet) {
      form.setFieldsValue(spreadsheet)
    }
  }, [spreadsheet])

  const onSave = async (val) => {
    if (spreadsheet) {
      val = {...spreadsheet, ...val}
    }
    onSuccess?.(val)
  }

  return <Modal
    width={400}
    open={true}
    maskClosable={false}
    onCancel={onCancel}
    footer={null}
    title={'Add Spreadsheets'}
  >
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='tag' rules={[{ required: true, message: 'Please enter spreadsheet name' }]}>
        <Input type='text' style={{width: 300}} />
      </Form.Item>

      <Row justify={'end'}>
        <Space>
          <Button htmlType="button" onClick={onCancel}>Cancel</Button>
          <Button type="primary" htmlType="submit">Save</Button>
        </Space>
      </Row>
    </Form>

  </Modal>
}

CreateSpreadsheetModal.show = (props: CreateSpreadsheetModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<CreateSpreadsheetModal
    {...props}
    onCancel={(e) => {
      props.onCancel?.(e)
      root.unmount()
    }}
    onSuccess={(...args) => {
      props.onSuccess?.(...args)
      root.unmount()
    }}
  />);
}